import axios from 'axios'
import apiUrl from '../../api.config'

const AudioService = {
  async speechToText(audioBlob, patientId) {
    const formData = new FormData()
    formData.append('audio_file', audioBlob, 'recording.mp3')
    if (patientId) {
      formData.append('patient_id', patientId)
    }

    try {
      const response = await axios.post(apiUrl + 'voice/stt', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error('Speech to text error:', error)
      throw error
    }
  }
}

export default AudioService
